if (!customElements.get('nuvemora-direct-checkout')) {
  customElements.define(
    'nuvemora-direct-checkout',
    class NuvemoraDirectCheckout extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-nuvemora-direct-checkout]');
        this.form = this.closest('form[data-type="add-to-cart-form"]');

        if (!this.button || !this.form) return;

        this.button.addEventListener('click', () => this.goToCheckout());
      }

      goToCheckout() {
        if (!this.form.reportValidity()) return;

        const variantInput = this.form.querySelector('input[name="id"]');
        const quantityInput = this.form.querySelector('input[name="quantity"]');
        const variantId = variantInput?.value;
        const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);

        if (!variantId || this.button.disabled) return;

        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');

        const root = window.Shopify?.routes?.root || '/';
        const checkoutUrl = new URL(`${root}cart/${encodeURIComponent(variantId)}:${quantity}`, window.location.origin);

        window.location.assign(checkoutUrl.toString());
      }
    }
  );
}
